import React, { useEffect, useRef } from "react";
import "./Services.css";
import Navbar from "./Navbar";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FaShippingFast, FaHeadset, FaShieldAlt } from "react-icons/fa";
import Footer from "./Footer";

export default function Services() {
  useEffect(() => {
    // jump to top when this route mounts
    window.scrollTo({ top: 0, behavior: "auto" }); // use 'smooth' if you prefer animation
  }, []);
  const productRef = useRef(null);
  const servicesRef = useRef(null);

  const products = [
    {
      id: 1,
      name: "Desktops & Laptops",
      image:
        "https://www-file.honor.com/content/dam/honor/sa-en/blog/2024/difference-between-laptop-and-desktop/pc-3.jpg",
    },
    {
      id: 2,
      name: "Servers",
      image:
        "https://www.racksolutions.com/news//app/uploads/AdobeStock_87909563.jpg",
    },
    {
      id: 3,
      name: "Printers",
      image: "https://article.images.consumerreports.org/image/upload/w_652,f_auto,q_auto,ar_16:9,c_lfill/v1750267954/prod/content/dam/CRO-Images-2025/Electronics/CR-Electronics-InlineHero-Best-Printers-of-Year-0625",
    },
    {
      id: 4,
      name: "CCTV Systems",
      image:
        "https://ipmgroupuk.com/wp-content/uploads/2024/07/4K-Cameras.webp",
    },
    {
      id: 5,
      name: "Speakers and Audio",
      image:
        "https://www.popsci.com/wp-content/uploads/2022/02/09/best-stereo-speakers-header.jpg?quality=85&w=1440",
    },
    // {
    //   id: 6,
    //   name: "Epson EcoTank L3250 Printer",
    //   image:
    //     "https://5.imimg.com/data5/SELLER/Default/2022/8/BY/FG/LS/87090341/epson-l3250-wi-fi-all-in-one-ink-tank-printer.jpg",
    // },
    // {
    //   id: 7,
    //   name: "Samsung Odyssey G9 Gaming Monitor",
    //   image:
    //     "https://images.samsung.com/is/image/samsung/p6pim/in/lc49g95tswxxl/gallery/in-odyssey-g9-lc49g95tswxxl-413473838?$650_519_PNG$",
    // },
    // {
    //   id: 8,
    //   name: "Canon CanoScan LiDE 400 Scanner",
    //   image: "https://m.media-amazon.com/images/I/61btKcZW2GL._AC_SL1500_.jpg",
    // },
  ];

  const services = [
    {
      id: 1,
      name: "AMC Services",
    },
    {
      id: 2,
      name: "FMS Services",
    },
    {
      id: 3,
      name: "Call-Based Support",
    },
    // {
    //   id: 4,
    //   name: "Logitech MX Mechanical Keyboard",
    // },
    // {
    //   id: 5,
    //   name: "Logitech MX Master 3S Wireless Mouse",
    // },
    // {
    //   id: 6,
    //   name: "Epson EcoTank L3250 Printer",
    // },
    // {
    //   id: 7,
    //   name: "Samsung Odyssey G9 Gaming Monitor",
    // },
    // {
    //   id: 8,
    //   name: "Canon CanoScan LiDE 400 Scanner",
    // },
  ];

  const features = [
    {
      icon: <FaShippingFast />,
      title: "Fast Delivery",
      text: "Free and reliable shipping on all orders.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      text: "We're here to help whenever you need us.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Secure Payment",
      text: "Your transactions are safe and encrypted.",
    },
  ];

  // const scroll = (direction, ref) => {
  //   const current = ref?.current;
  //   if (current) {
  //     current.scrollBy({
  //       left: direction === "left" ? -300 : 300,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  return (
    <div>
      <Navbar />
      <div className="services-title">
        <h1>Services and Products</h1>
      </div>

      <div className="product-section">
        <h2 className="section-title">Our Computer Hardware Products</h2>
        <div className="scroll-container">
          {/* <button
            className="scroll-btn left"
            onClick={() => scroll("left", productRef)}
          >
            <ChevronLeft size={28} />
          </button> */}

          <div className="product-row" ref={productRef}>
            {products.map((product) => (
              <div className="product-card" key={product.id}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <p className="product-name">{product.name}</p>
              </div>
            ))}
          </div>

          {/* <button
            className="scroll-btn right"
            onClick={() => scroll("right", productRef)}
          >
            <ChevronRight size={28} />
          </button> */}
        </div>
      </div>

      <div className="services-section">
        <h2 className="services-section-title">Services Offered By Us</h2>
        <div className="services-scroll-container">
          {/* <button
            className="services-scroll-btn left"
            onClick={() => scroll("left", servicesRef)}
          >
            <ChevronLeft size={28} />
          </button> */}

          <div className="services-row" ref={servicesRef}>
            {services.map((service) => (
              <div className="services-card" key={service.id}>
                <p className="services-name">{service.name}</p>
              </div>
            ))}
          </div>

          {/* <button
            className="services-scroll-btn right"
            onClick={() => scroll("right", servicesRef)}
          >
            <ChevronRight size={28} />
          </button> */}
        </div>
      </div>
      <div className="features-container">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <div className="feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.text}</p>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}
